export interface TikTokEventPropertiesTemplate extends Record<string, unknown> {
  content_type: string;
  content_id: string;
}
export const tikTokEventPropertiesTemplate: TikTokEventPropertiesTemplate = {
  content_type: 'product',
  content_id: 'fresh_food',
};

export const currencyUSD = 'USD';
export const US_COUNTRY_CODE = '1';
